import { render, staticRenderFns } from "./SupportTickets.vue?vue&type=template&id=3e9061fc&scoped=true&lang=pug&"
import script from "./SupportTickets.vue?vue&type=script&lang=js&"
export * from "./SupportTickets.vue?vue&type=script&lang=js&"
import style0 from "./SupportTickets.vue?vue&type=style&index=0&id=3e9061fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e9061fc",
  null
  
)

export default component.exports